module.exports = __webpack_public_path__ + "static/media/16IT131.74176550.jpeg";